import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ChecklistTemplateService } from '../../../../../../core/services/checklist-template.service';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';

interface FormValue {
  description: string;
}

@Component({
  selector: 'kt-checklist-template',
  templateUrl: './checklist-template.component.html',
})
export class ChecklistTemplateComponent implements OnInit {
  form: FormGroup;
  index = '';
  checklist = [];
  private _templateId: number;
  loaded = true;
  @Input() set templateId(value: number) {
    if (!value) {
      this.checklist = [];
      return;
    }
    this._templateId = value;
    this.loadChecklist(value);
  }
  @Input() mode;
  @Input() lockedByAdmin;

  constructor(
    private formBuilder: FormBuilder,
    private checklistTemplateService: ChecklistTemplateService,
    private cdr: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      description: [null, Validators.required],
    });
    if (this.lockedByAdmin) this.mode = 'view';
    // View Mode
    if (this.mode === 'view') this.form.disable();
  }

  reset(): void {
    this.index = '';
    this.form.reset();
    const nameFormControl = this.form.get('description') as FormControl;
    nameFormControl.setErrors(null);
  }

  mapFormToChecklist(value: FormValue): any {
    return {
      description: value.description,
    };
  }

  mapChecklistToForm(item): FormValue {
    return {
      description: item.description,
    };
  }

  addItem(event: Event): void {
    event.stopPropagation();
    const formValue = this.form.value;

    if (!formValue.description) {
      return;
    }

    let checklistItems = [...this.checklist];

    if (this.index) {
      checklistItems = checklistItems.map((item, index) =>
        index === +this.index ? { ...item, ...this.mapFormToChecklist(formValue) } : item,
      );
    } else {
      checklistItems.unshift(this.mapFormToChecklist(formValue));
    }

    this.checklist = checklistItems;
    this.updateFinalChecklist();
    this.reset();
  }

  updateItem(event: Event, idx: number): void {
    event.stopPropagation();

    const item = this.checklist.find((record, index) => index === idx);

    this.index = `${idx}`;
    this.form.patchValue(this.mapChecklistToForm(item));
  }

  cancelItemUpdate(event: Event): void {
    event.stopPropagation();

    this.reset();
  }

  deleteItem(event: Event, idx: number): void {
    event.stopPropagation();
    const _title = 'Delete Checklist Item';
    const _description = 'Are you sure you want to delete this item?';
    const dialogRef = this.layoutUtilsService.confirmAction(_title, _description, 'Loading...');
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      idx === 0 ? this.checklist.shift() : this.checklist.splice(idx, 1);
      this.updateFinalChecklist();
    });
  }
  updateFinalChecklist() {
    if (this.checklist.length > 0) {
      this.checklistTemplateService
        .updateChecklist({ check_list_templates: this.checklist }, this._templateId)
        .subscribe(() => {
          setTimeout(() => {
            this.loadChecklist(this._templateId);
            this.loaded = true;
            this.cdr.detectChanges();
            this.layoutUtilsService.showActionNotification(
              'Item updated successfully',
              MessageType.Update,
              3000,
              false,
              false,
            );
          }, 1000);
        });
    }
  }

  loadChecklist(templateID) {
    this.checklistTemplateService.getChecklist(templateID).subscribe((checklistItems) => {
      this.checklist = checklistItems?.data || [];
    });
  }
}
